<template>
  <el-dialog
    :visible="visible"
    :show-close="false"
    width="60%"
    class="edit-detail-dialog"
    center
    @close="handleDialogClose"
    :close-on-click-modal="false">
    <span slot="title" class="title-container">
      <span class="title-text">{{factoryName + $t('factoryLabelPrint.templateContentEditing')}}</span>
      <img
        src="@/assets/close.png"
        class="close-image"
        @click="close"
      />
    </span>
    <el-form class="el-form" :model="form" ref="refForm" :rules="rules" label-width="120px">
      <el-form-item label-width="0">
        <el-col :span="11">
          <el-form-item :label="$t('factoryLabelPrint.materialNo') + ':'" prop="materialNo">
            <el-input
              v-model.trim="form.materialNo"
              name="materialNo"
              type="text"
              autocomplete="on"
              clearable
              size="small"
              maxlength="64"
            />
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item :label="$t('factoryLabelPrint.materialName') + ':'" prop="materialName">
            <el-input
              v-model.trim="form.materialName"
              name="materialName"
              type="text"
              autocomplete="on"
              clearable
              size="small"
              maxlength="64"
            />
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item label-width="0">
        <el-col :span="11">
          <el-form-item :label="$t('common.contractNo') + ':'" prop="contractNo">
            <el-input
              v-model.trim="form.contractNo"
              name="materialNo"
              type="text"
              autocomplete="on"
              clearable
              size="small"
              maxlength="64"
            />
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item :label="$t('factoryLabelPrint.deliveryDate') + ':'" prop="deliveryDate">
            <el-date-picker
              v-model="form.deliveryDate"
              type="date"
              size="small"
              style="width: 100%;">
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item :label="$t('common.stylePreview') + ':'" style="margin-bottom: 0">
      </el-form-item>
      <el-form-item>
        <el-col :span="15">
          <iframe
            id="labelIFrameJianHeDialog"
            scrolling="auto"
            width="520"
            height="260"
            frameborder="0"
            style="background: #E9E9E9;"
          ></iframe>
        </el-col>
      </el-form-item>
    </el-form>
    <span slot="footer">
        <el-button size="small" @click="close">{{$t('common.cancel')}}</el-button>
        <el-button
          size="small"
          type="primary"
          @click="submitForm">
            {{$t('common.print')}}
        </el-button>
      </span>
  </el-dialog>
</template>

<script>
  import {
    initJianHeLabelFrame,
    printFactoryLabel,
  } from '@/utils/factory-label';

  export default {
    name: "JianHeLabelDialog",
    props: {
      factoryName: {
        type: String,
        default: '',
      },
      visible: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        form: {
          materialNo: undefined,
          materialName: undefined,
          contractNo: undefined,
          deliveryDate: undefined,
        },
        rules: {
          materialNo: [{
            required: true,
            trigger: 'blur',
            message: this.$t('factoryLabelPrint.materialNoCanNotBeEmpty')
          }],
          materialName: [{
            required: true,
            trigger: 'blur',
            message: this.$t('factoryLabelPrint.materialNameCanNotBeEmpty')
          }],
          contractNo: [{
            required: true,
            trigger: 'blur',
            message: this.$t('validate.contractNoCanNotBeEmpty')
          }],
          deliveryDate: [{
            required: true,
            trigger: 'blur',
            message: this.$t('factoryLabelPrint.deliveryDateCanNotBeEmpty')
          }],
        }
      };
    },
    watch: {
      visible(newValue) {
        if (newValue) {
          setTimeout(() => {
            this.initJianHeLabelFrame();
          });
        }
      }
    },
    methods: {
      handleDialogClose() {
        this.close();
      },
      close() {
        this.$emit('update:visible', false);
        this.$emit('close');
        if (this.$refs.refForm && typeof this.$refs.refForm.clearValidate === 'function') {
          this.$refs.refForm.clearValidate();
        }
      },
      submitForm() {
        this.$refs.refForm.validate(async (valid) => {
          if (valid) {
            this.printJianHeLabelFrame();
          }
        });
      },
      initJianHeLabelFrame() {
        let iframe = document.getElementById('labelIFrameJianHeDialog');
        iframe = initJianHeLabelFrame({
          iframe,
          materialNo: '20300-0632',
          materialName: 'LS9929S',
          contractNo: 'H221-18120240',
          deliveryDate: '2018/09/07',
        });
        iframe.contentWindow.document.close();
      },
      printJianHeLabelFrame() {
        const {
          materialNo,
          materialName,
          contractNo,
          deliveryDate,
        } = this.form;
        let iframe = document.getElementById('labelIFrameJianHeDialog');
        iframe = initJianHeLabelFrame({
          iframe,
          materialNo,
          materialName,
          contractNo,
          deliveryDate,
        });
        iframe.contentWindow.document.close();
        printFactoryLabel(iframe);
      },
    }
  }
</script>

<style scoped>
  .title-container {
    display: flex;
    display: -webkit-flex;
    flex-direction: row;
    justify-content: space-between;
    background: -webkit-linear-gradient(#F9F9F9, #EEEEEE);
    background: -o-linear-gradient(#F9F9F9, #EEEEEE);
    background: -moz-linear-gradient(#F9F9F9, #EEEEEE);
    background: linear-gradient(#F9F9F9, #EEEEEE);
    padding: 10px 15px;
    align-items: center;
  }

  .title-text {
    color: #404040;
    font-size: 16px;
  }

  .el-form {
    margin: 0 30px;
  }

  .close-image {
    width: 22px;
    height: 22px;
    cursor: pointer;
    padding: 0 10px;
  }
</style>
<style>
  .edit-detail-dialog .el-dialog__header {
    padding: 0;
  }
</style>
